module.exports = __webpack_public_path__ + "img/video-lectures.0dd5181b.png";